import React from 'react';

const StencilIcon = () => {
  return <img src='/skill-icons/stencil.png' alt='stencil-logo' />;
};

export default StencilIcon;
